export function addSpace(values) {
  return values.map((int, i) => i > 0 ? ` ${int}` : int);
}
